//
// must match EnumDashboardRefreshFrequency.java
//
export const MANUAL = 'manual';
export const HOURLY = 'hourly';
export const DAILY = 'daily';
export const EVERY_5_MINUTES = 'every_5_minutes';
